import { Component, OnChanges, OnInit } from "@angular/core";
import "./customer-subscriptions-page.component.scss";

@Component({
    selector: "customer-subscriptions-page",
    template: require("./customer-subscriptions-page.component.html")
})
export class CustomerSubscriptionsPageComponent implements OnInit, OnChanges {


    constructor() {
    }

    ngOnInit() {
    }

    ngOnChanges() {
    }

    // ---

}
